import { CustomSearchBox } from 'components/app-container/custom-search-box/CustomSearchBox';
import { UPDropdown } from 'components/dropdown';
import { FeatureAccessFeature } from 'constants/FeatureAccessFeature';
import { useTranslation } from 'react-i18next';
import {
  FEATURE_ACCESS__ANY_FEATURE,
  FEATURE_ACCESS__ANY_STATUS,
  FEATURE_ACCESS__DISABLED,
  FEATURE_ACCESS__ENABLED,
  FEATURE_ACCESS__FILTER_FEATURE,
  FEATURE_ACCESS__FILTER_STATUS,
  FEATURE_ACCESS__SEARCH_COMPANIES,
} from 'translations/constants';
import { FEATURE_LABEL_KEYS, FEATURES } from './constants';
import { FilterGroup, SearchWrapper, ToolbarRow } from './styles';
import { FeatureFilter, StatusFilter } from './utils';

interface FeatureAccessToolbarProps {
  onSearch: (term: string) => void;
  feature: FeatureFilter;
  onFeatureChange: (feature: FeatureFilter) => void;
  status: StatusFilter;
  onStatusChange: (status: StatusFilter) => void;
}

const FeatureAccessToolbar = (props: FeatureAccessToolbarProps): JSX.Element => {
  const { onSearch, feature, onFeatureChange, status, onStatusChange } = props;
  const [t] = useTranslation();

  return (
    <ToolbarRow>
      <SearchWrapper>
        <CustomSearchBox
          onSearch={onSearch}
          placeholder={t(FEATURE_ACCESS__SEARCH_COMPANIES)}
          testId="feature-access-search"
        />
      </SearchWrapper>
      <FilterGroup>
        <UPDropdown
          label={t(FEATURE_ACCESS__FILTER_FEATURE)}
          placeholder={t(FEATURE_ACCESS__ANY_FEATURE)}
          value={feature}
          onChange={event => onFeatureChange(event.target.value as FeatureAccessFeature | '')}
          items={FEATURES.map(value => ({ value, label: t(FEATURE_LABEL_KEYS[value]) }))}
          isFilter
          testId="feature-access-filter-feature"
        />
        <UPDropdown
          label={t(FEATURE_ACCESS__FILTER_STATUS)}
          placeholder={t(FEATURE_ACCESS__ANY_STATUS)}
          value={status}
          onChange={event => onStatusChange(event.target.value as StatusFilter)}
          items={[
            { value: 'enabled', label: t(FEATURE_ACCESS__ENABLED) },
            { value: 'disabled', label: t(FEATURE_ACCESS__DISABLED) },
          ]}
          isFilter
          testId="feature-access-filter-status"
        />
      </FilterGroup>
    </ToolbarRow>
  );
};

export default FeatureAccessToolbar;
